import { ClientGateway, SelectOption } from './types'

type OptionField = 'processingProvider' | 'paymentMethodType'

export const toUniqueOptions = (
  gateways: ClientGateway[],
  field: OptionField,
): SelectOption[] => {
  const values = gateways
    .map((gateway) => gateway[field])
    .filter((value) => Boolean(value))

  return Array.from(new Set(values))
    .sort()
    .map((value) => ({ label: value, value }))
}
